import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Hospital';

  constructor(private translate: TranslateService) {
    this.translate.addLangs(['zh-TW', 'en']);
    this.translate.setDefaultLang('zh-TW');
    const savedLang = localStorage.getItem('app_lang') || 'zh-TW';
    this.translate.use(savedLang);
  }
}

